import useStore from "./_store"
import * as TYPE from "./_store/type"
import { usePageStore } from '@/store'
import { mapState, mapActions, mapGetters } from '@/store/helpers'
import { mapState as rootMapState } from "pinia"
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
const ITEM_SIZE = 20
export default {
    i18next: {
        ns: 'md-featured-area-near'
    },
    _getUseStore: useStore,
    asyncData: mapAsyncData(asyncData),
    data: function() {
        return {
            featureArea: {},
            curPage: 1
        }
    },
    computed: {
        ...mapState({
            comunity: 'community',
            subdivision: 'subdivision'
        }),
        ...mapGetters({
            allNears: function(store) {
                return store.allNears.slice(0, ITEM_SIZE * this.curPage)
            },
            showShowMore: function(store) {
                return this.allNears < store.allNears
            }
        }),
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
        }),
        showAreaNear({ featureArea }) {
            return featureArea.type === 'city'
        },
        areaTitle({ featureArea }) {
            return this.$t("title", { city: featureArea.city, interpolation: { escapeValue: false } })
        },
        mobile({ platform }) {
            return platform.isMobile
        },
    },
    methods: {
        ...mapActions({
            setCommunity: TYPE.UPDATE_COMMUNITY,
            setSubdivision: TYPE.UPDATE_SUBDIVISION
        }),
        handleLink(nbr) {
            const { city, state } = this.featureArea
            return `/area/${city.toLowerCase()}-${state}/${nbr.toLowerCase()}/listings`.replaceAll(' ', '-')
        },
        showMore() {
            this.curPage++
        }
    }
}